<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
        >
        </front-table>
        <!--编辑界面-->
        <group-edit :edit_mode="edit_mode" :model="model" :single="single"
                    @success="handleSuccess" @cancel="handleCancel">
        </group-edit>

        <div class="clearfix"></div>
    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import GroupEdit from "../components/group-editor";

    export default {
        mixins: [FrontMixins],
        name: 'admin-group',
        components: {GroupEdit, FrontTable},
        created() {
            this.model =  'Admin.' + this.$route.meta.model;
        }
    }

</script>

<style lang="scss">

</style>
